module.exports = __webpack_public_path__ + "img/deafult.e4e7e503.svg";